package com.hyperether.goodjob.database

import app.cash.sqldelight.async.coroutines.awaitAsList
import app.cash.sqldelight.async.coroutines.awaitAsOneOrNull
import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import com.hyperether.goodjob.models.Plan
import com.hyperether.goodjob.repository.Mapper
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow

class PlanDaoImpl(private val sharedDatabase: SharedDatabase) : PlanDao {

    override suspend fun insertPlan(plan: Plan) {
        sharedDatabase { database ->
            database.appDatabaseQueries.transaction {
                database.appDatabaseQueries.insertPlan(
                    _id = plan._id,
                    name = plan.name,
                    price = plan.price,
                    perMonth = plan.perMonth,
                    description = plan.description,
                    storage = plan.storage,
                    planSupport = plan.planSupport,
                    limitManagers = plan.limitManagers,
                    limitUsers = plan.limitUsers,
                    isPopular = if (plan.isPopular == true) 1 else 0,
                    currency = plan.currency,
                    stripeProductId = plan.stripeProductId,
                    stripePriceId = plan.stripePriceId,
                    type = plan.type,
                    interval = plan.interval,
                    descriptions = Mapper().objectAsJson(plan.descriptions),
                    names = Mapper().objectAsJson(plan.names),
                    storages = Mapper().objectAsJson(plan.storages),
                    planSupports = Mapper().objectAsJson(plan.planSupports)
                )
            }
        }
    }

    override suspend fun updatePlanById(plan: Plan) {
        sharedDatabase { database ->
            database.appDatabaseQueries.transaction {
                database.appDatabaseQueries.updatePlanById(
                    id = plan._id,
                    _id = plan._id,
                    name = plan.name,
                    price = plan.price,
                    perMonth = plan.perMonth,
                    description = plan.description,
                    storage = plan.storage,
                    planSupport = plan.planSupport,
                    limitManagers = plan.limitManagers,
                    limitUsers = plan.limitUsers,
                    isPopular = if (plan.isPopular == true) 1 else 0,
                    currency = plan.currency,
                    interval = plan.interval,
                    stripeProductId = plan.stripeProductId,
                    stripePriceId = plan.stripePriceId,
                    type = plan.type,
                    descriptions = Mapper().objectAsJson(plan.descriptions),
                    names = Mapper().objectAsJson(plan.names),
                    storages = Mapper().objectAsJson(plan.storages),
                    planSupports = Mapper().objectAsJson(plan.planSupports)
                )
            }
        }
    }

    override suspend fun getPlansFlow(): Flow<List<com.hyperether.goodjob.database.Plan>> {
        return sharedDatabase { database ->
            database.appDatabaseQueries
                .getPlans()
                .asFlow()
                .mapToList(Dispatchers.Default)
        }
    }

    override suspend fun getPlanById(id: String): com.hyperether.goodjob.database.Plan? {
        return sharedDatabase { database ->
            database.appDatabaseQueries.getPlanById(id).awaitAsOneOrNull()
        }
    }

    override suspend fun getPlans(): List<com.hyperether.goodjob.database.Plan> =
        sharedDatabase { database ->
            database.appDatabaseQueries.getPlans().awaitAsList()
        }

    override suspend fun deletePlanById(id: String) {
        sharedDatabase { database ->
            database.appDatabaseQueries.deletePlanById(id)
        }
    }
}